import { useCallback, useRef } from "react";

export default function useDebounceCallback(
  callback: (...args: any[]) => void,
  dependencies: any[],
  timeout: number = 250,
) {
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout>>();

  return useCallback((...args: any[]) => {
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      callback(...args);
    }, timeout);
  }, dependencies);
}
